import { PureComponent } from 'react';

import { EditDateForManageAppointment } from '../../common';

export class EditBookingDate extends PureComponent {
  onSaveDataHandler = () => Promise.resolve();

  render() {
    return (
      <EditDateForManageAppointment onSaveDataHandler={this.onSaveDataHandler} {...this.props} />
    );
  }
}
